/* Liquid の辞書引きには上限があり（走査は先頭 250 件・直接引きは 1 ページ 20 ユニーク handle）、
   辞書が増えると対応表から値が漏れて画像が欠ける。Storefront API を全ページ送りして上限のない
   対応表を作る。アプリに `unauthenticated_read_product_listings` が無いと `image` は null で返る。 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.MaruniSwatchDictionary = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  /* 未サポートになった版を指定しても Shopify は最古のサポート版へ読み替えて応答する
     （shopify.dev「API versioning」）ので、版の失効で止まることはない。年 1 回を目安に上げる。 */
  var API_VERSION = '2026-01';
  var PAGE_SIZE = 250; /* Storefront API の 1 ページ上限 */
  /* ページ送りの打ち切り。hasNextPage が true のまま返り続ける異常時に送り続けないための安全弁で、
     250 × 40 = 10,000 件まで。辞書は 259 件なので実運用では当たらない。 */
  var MAX_PAGES = 40;
  var CACHE_KEY = 'mrn-swatch-dictionary';
  var CACHE_TTL_MS = 30 * 60 * 1000; /* 辞書は管理画面での手動運用なので、タブ内で 30 分は使い回す */

  /* 画像は `file_reference` → MediaImage。200px は Liquid 側の `image_url: width: 200` と同じ寸法。 */
  var QUERY = [
    'query SwatchDictionary($first: Int!, $cursor: String) {',
    '  metaobjects(type: "swatch", first: $first, after: $cursor) {',
    '    pageInfo { hasNextPage endCursor }',
    '    nodes {',
    '      key: field(key: "key") { value }',
    '      group: field(key: "group") { value }',
    '      label: field(key: "label") { value }',
    '      image: field(key: "image") {',
    '        reference { ... on MediaImage { image { url(transform: { maxWidth: 200, maxHeight: 200 }) } } }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  /* キーは辞書の値（管理画面で先方が入力する文字列）なので、`__proto__` のような名前でも
     プロトタイプに触れないよう prototype の無いオブジェクトで持つ。 */
  function emptyMap() {
    return { fabric: Object.create(null), wood: Object.create(null) };
  }

  /* Option の値から辞書のキーを作る。snippets/maruni-swatch-image.liquid と同じ規則。
     - fabric: 値の `#` 以降＝布NO（`M-06 グレー #2939` → `2939`。辞書の `key`）。`#` が無い値は引けない
     - wood: 値そのもの（`オーク ナチュラルクリア(C-0)`。辞書の `label` と同形） */
  function swatchKey(group, value) {
    var str = value == null ? '' : String(value);
    if (group === 'wood') return str.trim() || null;
    if (group === 'fabric') {
      var at = str.lastIndexOf('#');
      if (at < 0) return null;
      var key = str.slice(at + 1).trim();
      return key || null;
    }
    return null;
  }

  /* 辞書のキーは group で変わる。fabric は `key`（布NO）、wood は `label`（Option 値と同形）。
     ceramic / steel_* は商品ページに色見本の UI が無いので対応表に入れない。 */
  function entryKey(node) {
    var group = node && node.group && node.group.value;
    if (group === 'fabric') return { group: group, key: node.key && node.key.value };
    if (group === 'wood') return { group: group, key: node.label && node.label.value };
    return null;
  }

  function entryImage(node) {
    var ref = node && node.image && node.image.reference;
    return ref && ref.image && ref.image.url ? ref.image.url : null;
  }

  /* API の nodes を対応表に足す。同じキーが重複したときは先に来た方（辞書の並び順）を採る。 */
  function addNodes(map, nodes) {
    var added = 0;
    (nodes || []).forEach(function (node) {
      var ek = entryKey(node);
      var url = entryImage(node);
      if (!ek || !ek.key || !url) return;
      var key = String(ek.key).trim();
      if (!key || key in map[ek.group]) return;
      map[ek.group][key] = url;
      added++;
    });
    return added;
  }

  /* cursor pagination で全ページを読む。fetchImpl は window.fetch と同じ契約（テストでは差し替える）。
     応答が GraphQL errors を含む・HTTP エラー・形が違う、のいずれかで reject する。 */
  function fetchAll(fetchImpl, options) {
    var opts = options || {};
    var endpoint = opts.endpoint;
    var token = opts.token;
    var pageSize = opts.pageSize || PAGE_SIZE;
    var maxPages = opts.maxPages || MAX_PAGES;
    var map = emptyMap();
    var pages = 0;

    function page(cursor) {
      pages++;
      return fetchImpl(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query: QUERY, variables: { first: pageSize, cursor: cursor || null } })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('swatch dictionary: HTTP ' + res.status);
          return res.json();
        })
        .then(function (json) {
          if (json && json.errors && json.errors.length) {
            throw new Error('swatch dictionary: ' + (json.errors[0].message || 'GraphQL error'));
          }
          var conn = json && json.data && json.data.metaobjects;
          if (!conn) throw new Error('swatch dictionary: metaobjects missing in response');
          addNodes(map, conn.nodes);
          var info = conn.pageInfo || {};
          if (info.hasNextPage && info.endCursor && pages < maxPages) return page(info.endCursor);
          return { map: map, pages: pages, truncated: !!info.hasNextPage };
        });
    }

    return page(null);
  }

  function lookup(map, group, value) {
    if (!map || !map[group]) return null;
    var key = swatchKey(group, value);
    if (!key) return null;
    /* sessionStorage から戻した対応表は通常のオブジェクトなので、継承プロパティを拾わないよう own property だけ見る */
    return Object.prototype.hasOwnProperty.call(map[group], key) ? map[group][key] : null;
  }

  /* data-mrn-swatch-group / data-mrn-swatch-value を持つチップのうち、画像が無いものに <img> を足す。
     Liquid が描いた <img>（snippets/maruni-swatch-image.liquid）と同じ属性にする。
     トリガー（data-mrn-opener-chip）は常に見えているので遅延読込にしない。 */
  function hydrate(scope, map) {
    if (!scope || !map || !scope.querySelectorAll) return 0;
    var count = 0;
    var chips = scope.querySelectorAll('[data-mrn-swatch-group]');
    Array.prototype.forEach.call(chips, function (chip) {
      if (chip.querySelector('.mrn-swatch__img')) return;
      var src = lookup(map, chip.getAttribute('data-mrn-swatch-group'), chip.getAttribute('data-mrn-swatch-value'));
      if (!src) return;
      var img = chip.ownerDocument.createElement('img');
      img.className = 'mrn-swatch__img';
      img.setAttribute('data-mrn-swatch-hydrated', ''); /* Liquid 由来の <img> と見分けるため（確認用） */
      img.src = src;
      img.alt = '';
      img.width = 200;
      img.height = 200;
      if (!chip.hasAttribute('data-mrn-opener-chip')) img.loading = 'lazy';
      chip.appendChild(img);
      count++;
    });
    return count;
  }

  function endpointFor(shop) {
    return 'https://' + shop + '/api/' + API_VERSION + '/graphql.json';
  }

  function readCache(storage) {
    try {
      var raw = storage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.map || typeof data.at !== 'number') return null;
      if (Date.now() - data.at > CACHE_TTL_MS) return null;
      return data.map;
    } catch (e) {
      return null;
    }
  }

  function writeCache(storage, map) {
    try {
      storage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), map: map }));
    } catch (e) {
      /* 容量超過・プライベートモードなどは無視（キャッシュが無くても動く） */
    }
  }

  /* ページ内で 1 回だけ取得する。失敗も含めて Promise を持ち続け、Section Rendering のたびに
     取得し直さない（失敗時は Liquid の表示のまま＝フォールバック）。 */
  var pending = null;
  function load(config) {
    if (pending) return pending;
    if (!config || !config.shop || !config.token || typeof fetch !== 'function') {
      pending = Promise.resolve(null);
      return pending;
    }
    var storage = null;
    try { storage = window.sessionStorage; } catch (e) { storage = null; }
    var cached = storage ? readCache(storage) : null;
    if (cached) {
      pending = Promise.resolve(cached);
      return pending;
    }
    pending = fetchAll(fetch, { endpoint: endpointFor(config.shop), token: config.token })
      .then(function (result) {
        if (storage && !result.truncated) writeCache(storage, result.map);
        return result.map;
      })
      .catch(function (err) {
        if (typeof console !== 'undefined' && console.warn) console.warn(err && err.message ? err.message : err);
        return null;
      });
    return pending;
  }

  /* セクションのルートから設定を読み、辞書を取得（またはキャッシュから）して、画像の無いチップを埋める。 */
  function apply(doc) {
    var d = doc || document;
    var rootEl = d.querySelector('[data-mrn-swatch-shop]');
    if (!rootEl) return Promise.resolve(0);
    var config = { shop: rootEl.getAttribute('data-mrn-swatch-shop'), token: rootEl.getAttribute('data-mrn-swatch-token') };
    return load(config).then(function (map) {
      return map ? hydrate(d, map) : 0;
    });
  }

  return {
    API_VERSION: API_VERSION,
    QUERY: QUERY,
    emptyMap: emptyMap,
    swatchKey: swatchKey,
    addNodes: addNodes,
    fetchAll: fetchAll,
    lookup: lookup,
    hydrate: hydrate,
    endpointFor: endpointFor,
    load: load,
    apply: apply
  };
});
